window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var cfg = ns.config;
  var st = ns.state;

  function updateLocationFilter() {
    var state = st.get();
    if (state.venue === null) {
      $(".filter-location").text("All Locations");
      $(".dropdown-room > .dropdown-menu > a, .dropdown-room > .dropdown-menu > h6").each(function (index, ele) {
        $(ele).show();
      });
    } else {
      $.each(locations, function (locationId, location) {
        if (location.venueId === state.venue) {
          $(".filter-location").text(location.name);
          return false;
        }
      });
      $(".dropdown-room > .dropdown-menu > a, .dropdown-room > .dropdown-menu > h6").each(function (index, ele) {
        var $ele = $(ele);
        if ($ele.attr("data-venue") != state.venue && index > 0) {
          $ele.hide();
        } else {
          $ele.show();
        }
      });
    }
  }

  function updateRoomFilter() {
    var state = st.get();
    if (state.event) {
      $.each(locations, function (locationId, location) {
        if (location.venueId === state.venue) {
          $.each(location.rooms, function (roomId, room) {
            if ($.inArray(state.event, room.eventIds) > -1) {
              $(".filter-room").html(room.name);
              return false;
            }
          });
          return false;
        }
      });
    } else {
      $(".filter-room").text("All Experiences");
    }
  }

  function updateTableFilter() {
    var state = st.get();
    if (state.event) {
      $.each(locations, function (locationId, location) {
        if (location.venueId === state.venue) {
          $.each(location.tables, function (tableId, table) {
            if ($.inArray(state.event, table.eventIds) > -1) {
              $(".filter-table").html(table.name);
              return false;
            }
          });
          return false;
        }
      });
    } else {
      $(".filter-table").text("All Seating Areas");
    }
  }

  function updatePlayerFilter() {
    var state = st.get();
    if (state.players) {
      $(".filter-player").text(state.players + " People");
    } else {
      $(".filter-player").text("2 People");
    }
  }

  function updateAllFilters(opt) {
    opt = opt || {};
    if (opt.updateDate !== false) {
      var state = st.get();
      var currentDate = moment(state.start || cfg.START_SEARCH_DATE, "YYYYMMDD");
      $(".filter-date").text(currentDate.format("MMMM D, YYYY"));
      if (typeof $.fn.datepicker === "function") {
        $(".btn-calendar").datepicker("update", currentDate.toDate());
      }
    }
    updateLocationFilter();
    updateRoomFilter();
    updateTableFilter();
    updatePlayerFilter();
  }

  function bindHandlers() {
    var updateUrl = ns.url.updateUrl;
    var updateCalendar = ns.calendar.updateCalendar;

    // Guard against bootstrap-datepicker failing to load (network failure,
    // content blocker, CDN miss). Without this, the missing plugin throws
    // mid-init and prevents the rest of bindHandlers() from running, which
    // would break every dropdown on the booking page. Skipping only the
    // popup date input keeps the inline calendar grid and filters working.
    if (typeof $.fn.datepicker === "function") {
      $(".btn-calendar")
        .datepicker({
          format: "dd/mm/yyyy",
          autoclose: true,
          maxViewMode: 0,
          orientation: "bottom left",
          startDate: cfg.today.toDate(),
        })
        .on("changeDate", function (e) {
          var state = st.get();
          state.start = moment(e.date).format("YYYYMMDD");
          state.action = "calendar";
          updateCalendar({ clear: true });
          updateUrl(cfg.PAGE_CALENDAR);
        });
    } else if (window.Sentry && typeof Sentry.captureMessage === "function") {
      Sentry.captureMessage("bootstrap-datepicker failed to load", "warning");
    }

    $(".dropdown-location").on("click", "a", function (e) {
      var $a = $(e.currentTarget);
      var state = st.get();

      state.venue = parseInt($a.attr("data-venue"));
      state.event = null;
      state.end = null;

      if (state.venue === 0) {
        state.venue = null;
        updateLocationFilter();
        updateCalendar({ clear: true });
        updateUrl(cfg.PAGE_CALENDAR);
        return;
      }

      updateLocationFilter();
      updateCalendar({ clear: true });
      updateUrl(cfg.PAGE_CALENDAR);
    });

    $(".dropdown-room").on("click", "a", function (e) {
      var $a = $(e.currentTarget);
      var state = st.get();
      var venue = parseInt($a.attr("data-venue"));
      var event = parseInt($a.attr("data-event"));
      state.end = null;

      var events = $a.attr("data-event").split(",").map(function (ev) {
        return parseInt(ev);
      });

      if (event === 0) {
        state.event = null;
        state.events = undefined;
        updateRoomFilter();
        updateCalendar({ clear: true });
        updateUrl(cfg.PAGE_CALENDAR);
        return;
      }

      state.venue = venue;
      state.event = event;
      state.events = events;
      updateRoomFilter();
      updateCalendar({ clear: true });
      updateUrl(cfg.PAGE_CALENDAR);
    });

    $(".dropdown-table").on("click", "a", function (e) {
      var $a = $(e.currentTarget);
      var state = st.get();
      var venue = parseInt($a.attr("data-venue"));
      var event = parseInt($a.attr("data-event"));
      state.end = null;

      var events = $a.attr("data-event").split(",").map(function (ev) {
        return parseInt(ev);
      });

      if (event === 0) {
        state.event = null;
        state.events = undefined;
        updateTableFilter();
        updateCalendar({ clear: true });
        updateUrl(cfg.PAGE_CALENDAR);
        return;
      }

      state.venue = venue;
      state.event = event;
      state.events = events;
      updateTableFilter();
      updateCalendar({ clear: true });
      updateUrl(cfg.PAGE_CALENDAR);
    });

    $(".dropdown-player").on("click", "a", function (e) {
      var $a = $(e.currentTarget);
      var state = st.get();
      state.players = parseInt($a.attr("data-player"));
      updatePlayerFilter();
      updateCalendar({ clear: true });
      updateUrl(cfg.PAGE_CALENDAR);
    });

    $("body").on("click", ".link-clear-filters", function (e) {
      e.preventDefault();
      $(".filter-date").text("Any Dates");
      $(".filter-room").text("All Experiences");
      $(".filter-location").text("All Locations");
      $(".btn-restart").blur();
      st.reset();
      updateCalendar({ clear: true });
      updateUrl(cfg.PAGE_CALENDAR);
    });
  }

  ns.filters = {
    updateLocationFilter: updateLocationFilter,
    updateRoomFilter: updateRoomFilter,
    updateTableFilter: updateTableFilter,
    updatePlayerFilter: updatePlayerFilter,
    updateAllFilters: updateAllFilters,
    bindHandlers: bindHandlers,
  };
})(window.EM.booking);
